import * as React from 'react'
import Box from '@mui/material/Box'
import { useState } from 'react'
import { CircularProgress, Typography } from '@mui/material'
import { IChartPackets, transformLogToChartPackets } from '../services/transformLogToChartPacket'
import PacketsCharts from './packetsCharts/PacketsCharts'
import { Page } from './commons/Page'
import UploadFileDialog from './UploadFileDialog'
import { StandardChip } from './commons/fileDropzone/FileDropzone'
import { EStandard } from '../services/enums/EStandard'

export default function ChartContainer() {
    const [loading, setLoading] = useState<boolean>(true)
    const [fileName, setFileName] = useState<string>()
    const [standard, setStandard] = useState<EStandard>()
    const [packets, setPackets] = useState<IChartPackets & { standard: EStandard; timestampRange: [number, number] }>()

    const onFileContent = (content: string, forceStandard?: EStandard, preProcessSample?: number) => {
        setLoading(true)
        setTimeout(() => {
            const chartPackets = transformLogToChartPackets(content, forceStandard, preProcessSample)

            setPackets(chartPackets)
            setLoading(false)
        }, 1000)
    }

    const onFileName = (name: string | undefined) => {
        setFileName(name)
    }

    const onStandard = (standard: EStandard) => {
        setStandard(standard)
    }

    return (
        <Page>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Box
                    sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1 }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {standard && <StandardChip standard={standard} />}
                        {fileName && (
                            <Typography variant='body1' sx={{ px: 1 }}>
                                {fileName}
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ mx: 1, display: 'flex', alignItems: 'center' }}>
                        <UploadFileDialog
                            onFileContent={onFileContent}
                            onFileName={onFileName}
                            onStandard={onStandard}
                            isNotCancellable={!packets}
                        />
                    </Box>
                </Box>
            </Box>
            {loading ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <CircularProgress disableShrink />
                    <Typography sx={{ p: 2 }}>Loading charts...</Typography>
                </Box>
            ) : packets ? (
                <Box sx={{ display: 'flex', width: '100%', height: '100%', overflow: 'clip' }}>
                    <PacketsCharts
                        timestampRange={packets.timestampRange}
                        dpr={packets.dpr}
                        tankPressures={packets.tankPressures}
                        ticks={packets.ticks}
                        modes={packets.modes}
                        magnitudes={packets.magnitudes}
                    />
                </Box>
            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <Typography variant='h6'>No data to display</Typography>
                </Box>
            )}
        </Page>
    )
}
